<template><span ref="host" class="museum-illustration"></span></template>
<script>
import { preloadExhibitionImage } from '../../utils/exhibitionImage';
export default {
  props: { src: String, alt: { type: String, default: '' }, thumbnail: Boolean, draggable: { type: Boolean, default: true } },
  watch: { src() { this.showImage(); } },
  mounted() { this.showImage(); },
  beforeUnmount() { this._closed = true; },
  methods: {
    async showImage() {
      const source = this.src;
      if (!source) { this.$refs.host?.replaceChildren(); return; }
      try {
        const ready = await preloadExhibitionImage(source, { maxDimension: this.thumbnail ? 384 : 1024 });
        if (this._closed || source !== this.src) return;
        // Append the decoded element itself. Creating another <img src> would
        // start a fresh request under no-store previews and lose the warm decode.
        const image = ready.parentElement && ready.parentElement !== this.$refs.host ? ready.cloneNode() : ready;
        image.alt = this.alt;
        image.draggable = this.draggable;
        this.$refs.host.replaceChildren(image);
      } catch { /* Keep the image mount stable when a source is unavailable. */ }
    },
  },
};
</script>
<style scoped>
.museum-illustration{display:contents}
.museum-illustration :deep(img){display:block;width:100%;height:100%;object-fit:cover}
</style>
